import Vue from "vue"
import VueRouter from "vue-router"
import store from "./store"
import Dashboard from "./views/Dashboard.vue"

Vue.use(VueRouter)

const routes = [
	{
		path: "/",
		name: "Dashboard",
		component: Dashboard,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/Login",
		name: "Login",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "login" */ "./views/Login.vue"),
	},
	{
		path: "/MedEx",
		name: "MedEx",
		component: () =>
			import(/* webpackChunkName: "medexonline" */ "./views/MedEx.vue"),
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/MedExOnline",
		name: "MedEx Online",
		component: () =>
			import(
				/* webpackChunkName: "medexonline" */ "./views/MedExOnline.vue"
			),
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/Account",
		name: "Account",
		component: () =>
			import(/* webpackChunkName: "account" */ "./views/Account.vue"),
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/Settings",
		name: "Settings",
		component: () =>
			import(/* webpackChunkName: "settings" */ "./views/Settings.vue"),
		meta: {
			requiresAdmin: true,
		},
	},
]

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
})

router.beforeEach((to, from, next) => {
	// Guard routes that require authentication
	if (to.matched.some(route => route.meta.requiresAdmin)) {
		if (store.getters.isAdmin) {
			next()
		} else {
			next(false)
		}
	} else if (to.matched.some(route => route.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next()
		} else {
			next("/Login")
		}
	}
	// Prevent user from accessing login page if token exists. Redirect to Dashboard.
	else if (to.matched.some(route => route.name === "Login")) {
		if (store.getters.isLoggedIn) {
			next("/")
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router
